import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import { userReducer } from './components/user'
import { live_chats } from './components/chats'

export default combineReducers({
  routing: routerReducer,
  userReducer,
  live_chats
})


// WEBPACK FOOTER //
// ./src/reducer.js